export default "__VITE_ASSET__9b398d5b__"